import { Box } from '@react-three/flex';
import { observer } from 'mobx-react-lite';

import type { RoundedButtonProps } from './RoundedButton';
import { RoundedButton } from './RoundedButton';

type Props = RoundedButtonProps & {
  marginTop?: number;
  borderWidth?: number;
  radius?: number;
};

export const MoreCtaButton = observer(function MoreCtaButton(props: Props) {
  return (
    <Box
      centerAnchor
      marginTop={props.marginTop ?? 0}
      width={props.size.width}
      height={props.size.height}
    >
      <RoundedButton
        {...props}
        textProps={props.textProps}
        size={props.size}
        borderWidth={props.borderWidth ?? 1}
        radius={props.radius ?? 0}
      />
    </Box>
  );
});
